import {HealthCardEnum, HomeEnum, PerksEnum, ServicesEnum} from './mapRoutesEnum';

export const themeRoutesMapping = [
	HomeEnum.HOME_PAGE,
	ServicesEnum.SERVICES,
	HealthCardEnum.HEALTH_CARD,
	PerksEnum.PERKS,
] as string[];
